import {
  SummaryCard,
  SummaryCardTextSkeleton
} from './BudgetSummaryCard.styles.ts'
import { Skeleton } from '../../shared/ui/Skeleton'
import { HTMLAttributes } from 'react'

export const BudgetSummaryCardSkeleton = (
  props: HTMLAttributes<HTMLDivElement>
) => (
  <SummaryCard {...props}>
    <SummaryCardTextSkeleton>
      <Skeleton width="80%" height="18px" />
      <Skeleton width="60%" height="28px" />
      <Skeleton width="50%" height="12px" />
    </SummaryCardTextSkeleton>
  </SummaryCard>
)
